import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  transform(value: string | number, reverse?: boolean): string | undefined {
    if (value) {
      if (reverse) {
        let mValue = String(value);
        mValue = mValue
          .replace(/\./gi, '')
          .replace(',', '.')
          .replace(/[^0-9.]/, '')
          .replace('€', '');
        return mValue;
      } else {
        const mValue = Number.parseFloat(String(value));
        const s = new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
        }).format(mValue);
        return s;
      }
    }
    return undefined;
  }
}
